module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-d6d25fc9711f7b1980fdeae5ff53c8fa.png";